import { axios } from './config';

export const getExpbDocForSite = (siteId) => {
	const axiosAbortController = new AbortController();
	const request = {
		promise: () => {
			return axios.get(`/cb/expbDoc/${siteId}`, {
				signal: axiosAbortController.signal
			});
		},
		abort: () => {
			axiosAbortController.abort();
		}
	};

	return request;
};

export const createExpbDocForSite = (payload) => {
	return axios.post('/cb/expbDoc/create-config', payload);
};

export const updateExpbDocForSite = (payload) => {
	return axios.put(`/cb/expbDoc/update-config`, payload);
};

export const fetchExperimentalBlockSites = () => {
	return axios.get('/cb/expbDoc/fetch-experimental-block-sites');
};

export const fetchSelectiveRolloutSites = () => {
	return axios.get('/cb/expbDoc/fetch-selective-rollout-sites');
};

export const fetchGitBranches = () => {
	return axios.get(`/cb/framerateCoreDoc/gitBranches`);
};

export const getExperimentalSites = () => {
	return axios.get('/cb/expbDoc/get-experimental-sites');
};
